import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTestIssueTypes } from 'src/apps/mobile-sdk/services/MobileSdkSingleTestService';
import { MOBILE_SDK_TEST_ISSUE_TYPES } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

interface IUseMobileSdkTestIssueTypesQuery {
	testId: string;
}

export const useMobileSdkTestIssueTypesQuery = ({
	testId
}: IUseMobileSdkTestIssueTypesQuery): UseQueryResult<MobileIssueTypeCount[]> => {
	const issueTypesQuery = useQuery(
		[MOBILE_SDK_TEST_ISSUE_TYPES, testId],
		async (): Promise<MobileIssueTypeCount[]> =>
			getMobileSdkTestIssueTypes({
				testId
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return issueTypesQuery;
};
